<template>
  <div class="credits">
    <Wrapper class="container-fluid">
      <h1>Credits</h1>
      <div
        class="row"
        data-aos="fade-up"
        data-aos-duration="1000"
        data-aos-once="true"
      >
        <div class="col-xs-12 col-sm-12 col-md-5">
          <div class="img-wrapper">
            <NuxtImg
              format="avif"
              loading="lazy"
              :src="`${baseUrl}/popular.svg`"
              alt="showcase"
            />
          </div>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-7">
          <div class="content">
            <div class="sec">
              <h2 class="heading">Special Thanks To:</h2>
              <ol type="1">
                <li>
                  <p class="bold">Asset Providers</p>
                  <ol type="i">
                    <li>
                      <NuxtLink
                        to="https://www.flaticon.com/free-icons/vr"
                        target="_blank"
                        title="vr icons"
                        >Vr icons created by Chanut-is-Industries -
                        Flaticon</NuxtLink
                      >
                    </li>
                    <li>
                      <NuxtLink
                        to="https://www.flaticon.com/free-icons/arrow-key"
                        target="_blank"
                        title="arrow key icons"
                        >Arrow key icons created by Smashicons -
                        Flaticon</NuxtLink
                      >
                    </li>
                    <li>
                      <NuxtLink
                        to="https://www.flaticon.com/free-icons/keyboard"
                        target="_blank"
                        title="keyboard icons"
                        >Keyboard icons created by Freepik - Flaticon</NuxtLink
                      >
                    </li>
                    <li>
                      <NuxtLink
                        to="https://www.freepik.com/vectors/technology"
                        target="_blank"
                        >Technology vector created by stories -
                        www.freepik.com</NuxtLink
                      >
                    </li>
                    <li>
                      <NuxtLink
                        to="https://www.pexels.com/video/a-woman-taking-pictures-using-a-smartphone-7856998/"
                        target="_blank"
                      >
                        Woman taking pictures using a smartphone by Greta
                        Hoffman - Pexels</NuxtLink
                      >
                    </li>
                    <li>
                      <NuxtLink
                        to="https://www.pexels.com/video/a-young-woman-by-a-lake-taking-a-photo-with-her-smartphone-13158823/"
                        target="_blank"
                        >Woman by a lake taking photos by ed1toR - Pexels
                      </NuxtLink>
                    </li>
                    <li>
                      <NuxtLink
                        to="https://www.freepik.com/free-video/backpacker-snow_3057330"
                        target="_blank"
                      >
                        Backpacker snow video created by freepik -
                        www.freepik.com
                      </NuxtLink>
                    </li>
                    <li>
                      <NuxtLink
                        to="https://www.pexels.com/photo/green-light-bokeh-1048049/"
                        target="_blank"
                        >Green light bokeh by Scott Webb - Pexels</NuxtLink
                      >
                    </li>
                    <li>
                      <NuxtLink
                        to="https://www.pexels.com/photo/pink-neon-lights-701855/"
                        target="_blank"
                      >
                        Pink neon lights by louys - Pexels</NuxtLink
                      >
                    </li>
                    <li>
                      <NuxtLink
                        to="https://www.pexels.com/photo/blue-glass-bulding-139205/"
                        target="_blank"
                      >
                        Blue glass bulding by Scott Webb - Pexels
                      </NuxtLink>
                    </li>
                    <li>
                      <NuxtLink
                        to="https://www.pexels.com/video/light-purple-abstract-explosion-5453622/"
                        target="_blank"
                      >
                        Light purple abstract explosion by Rostislav Uzunov -
                        Pexels
                      </NuxtLink>
                    </li>
                  </ol>
                  <p class="desc"></p>
                </li>
                <li>
                  <p class="bold">3D Map System</p>
                  <ol type="i">
                    <li>
                      <NuxtLink to="https://leafletjs.com/" title="vr icons"
                        >Leafletjs</NuxtLink
                      >
                    </li>
                    <li>
                      <NuxtLink
                        to="https://github.com/tangrams/tangram"
                        title="vr icons"
                        >Tangram</NuxtLink
                      >
                    </li>
                  </ol>
                </li>
              </ol>
            </div>
          </div>
        </div>
      </div>
    </Wrapper>
  </div>
</template>

<script setup>
import Aos from "aos";
const config = useRuntimeConfig();
const baseUrl = config.public.NUXT_CDN_URL + "/static/website";

//seo meta tags
useSeoMeta({
  title: "Credits",
  description: "Special thanks to the asset providers and 3D map system",
  keywords:
    "credits, asset providers, 3D map system, leafletjs, tangram, flaticon, freepik, pexels",
});

//mouted
onMounted(() => {
  Aos.init();
});
</script>

<style lang="scss" scoped>
$class: ".credits";
#{$class} {
  $t_c: white;
  background-color: transparent;
  font-family: "Inter", sans-serif;
  padding: 2em;
  padding-top: 4em;
  font-size: 16px;
  @include respond-below(sm) {
    overflow: hidden;
    font-size: 12px;
    padding: 0;
    padding-top: 4em;
  }
  h1 {
    font-size: 2.6em;
    color: rgba(255, 255, 255, 0.85);
  }
  h2.heading {
    font-family: "Lato", sans-serif;
    font-size: 2.6em;
    color: $t_c;
    &.center {
      text-align: center;
    }
  }
  p {
    margin-top: 0.6em;
    font-family: "Roboto", sans-serif;
    color: $t_c;
    font-size: 1.1em;
    @include respond-below(sm) {
      font-size: 16px;
    }
    line-height: 25px;
    &.bold {
      font-weight: 700;
    }
    &.desc {
      margin-top: unset;
      /* margin-left: 1.1em; */
    }
  }
  .row {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    margin-top: 2em;
    @include respond-below(sm) {
      grid-template-columns: repeat(1, 1fr);
      margin-top: 0;
    }
  }
  .img-wrapper {
    display: flex;
    justify-content: center;
    top: 2em;
    img {
      max-height: min(85vh, 600px);
      @include respond-below(sm) {
        max-height: 290px;
      }
    }
  }
  .sec {
    &:not(:first-child) {
      margin-top: 2em;
    }
    ol {
      margin: 0;
      padding-left: 1em;

      /* list-style: none; */
      li {
        margin-top: 2em;
        @include respond-below(sm) {
          font-size: 14px;
        }
        a {
          color: rgba(255, 255, 255, 0.55);
        }
        &::marker {
          font-weight: 700;
          font-size: 16px;
        }

        &:not(:first-child) {
        }
      }
    }
  }
  .space-y {
    margin-block: 2em;
  }
  .content {
    display: flex;
    flex-flow: column wrap;
    align-items: center;
    @include respond-below(sm) {
      margin-top: 2em;
    }
  }
}
</style>
